import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/web.dom-collections.for-each';
import 'regenerator-runtime/runtime';
import { isWorldReadyInstance, Region } from '@paypalcorp/worldready-core';
import { assertType, assert, assertRange } from 'yaassertion';
import Cldr from 'cldrjs/dist/cldr';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}
var ADDRESS_LABEL_DISPLAY_NAME_TYPES = {
  COARSE_ADDRESS: "coarseAddress",
  PORTABLE_ADDRESS: "portableAddress",
  PORTABLE_ADDRESS_VALUES: "portableAddressValues",
  COARSE_ADDRESS_VALUES: "coarseAddressValues"
};
var DISPLAY_NAME_TYPES = Object.assign({}, ADDRESS_LABEL_DISPLAY_NAME_TYPES, {
  PERSON_NAME: "personName",
  REGION: "region",
  LANGUAGE: "language",
  DATE_TIME_FIELD: "dateTimeField",
  CURRENCY: "currency",
  MONTH: "month",
  DAY: "day",
  TERRITORY_NAME_SORT_KEY: "territoryNameSortKey",
  CURRENCY_NAME_SORT_KEY: "currencyNameSortKey"
});
var ENVIRONMENT = {
  PRODUCTION: "production"
};
var MESSAGE_MISSING = "\uE007\uE007";
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}

// Code borrowed from Cldrjs and adapted.
// TODO Improve Cldrjs API and make export() available.
// Note: Cldrjs unresolved module should resolve data when exporting.
var cldrParentLookup = function cldrParentLookup(cldr, locale) {
  if (locale === "root") {
    return;
  }

  // First, try to find parent on supplemental data.
  var parent = cldr.get(["supplemental/parentLocales/parentLocale", locale]);
  if (parent) {
    return parent;
  }

  // Or truncate locale.
  parent = locale.substr(0, locale.lastIndexOf("-"));
  if (!parent) {
    return "root";
  }
  return parent;
};
var _inheritanceChain = /*#__PURE__*/_regeneratorRuntime().mark(function _inheritanceChain(cldr, locale) {
  return _regeneratorRuntime().wrap(function _inheritanceChain$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return locale;
      case 2:
        if (locale = cldrParentLookup(cldr, locale)) {
          _context.next = 0;
          break;
        }
      case 3:
      case "end":
        return _context.stop();
    }
  }, _inheritanceChain);
});
function inheritanceChain(cldr, locale) {
  return _inheritanceChain(cldr, locale);
}
var DisplayNames = /*#__PURE__*/function () {
  /**
   * @param {Object} worldReady
   * @param {Object} options
   * @param {String} options.type
   */
  function DisplayNames(worldReady, options) {
    var _this = this;
    if (options === void 0) {
      options = {};
    }
    // Error Checks
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
      assertType(options.type, "options.type", ["string"]);
      assertRange(options.type, Object.values(DISPLAY_NAME_TYPES), "options.type must be one of the value from " + Object.values(DISPLAY_NAME_TYPES));
      if (options.fallback) {
        assertRange(options.fallback, ["code", "none"], "options.fallback must be 'none', or 'code'");
      }
      var _options = options,
        type = _options.type;
      if (type === DISPLAY_NAME_TYPES.PERSON_NAME) {
        Region.assertType(options.nameRegion, "options.nameRegion");
      }
      if (Object.values(ADDRESS_LABEL_DISPLAY_NAME_TYPES).includes(type)) {
        Region.assertType(options.addressRegion, "options.addressRegion");
      }
      if (type === DISPLAY_NAME_TYPES.PORTABLE_ADDRESS_VALUES) {
        assertRange(options.element, ["adminArea1", "adminArea2"], "options.element must be 'adminArea1' or 'adminArea2'");
      }
      if (type === DISPLAY_NAME_TYPES.COARSE_ADDRESS_VALUES) {
        assertRange(options.element, ["state", "city"], "options.element must be 'state' or 'city'");
      }
      if (type === DISPLAY_NAME_TYPES.DATE_TIME_FIELD) {
        assertRange(options.style, ["long", "short", "narrow", "abbreviated"], "options.style must be 'long', 'short', 'narrow' or 'abbreviated'");
      }
      if (type === DISPLAY_NAME_TYPES.MONTH) {
        assertRange(options.style, ["wide", "narrow", "abbreviated"], "options.style must be 'wide', 'narrow' or 'abbreviated'");
      }
      if (type === DISPLAY_NAME_TYPES.DAY) {
        assertRange(options.style, ["wide", "narrow", "short", "abbreviated"], "options.style must be 'wide', 'narrow', 'short' or 'abbreviated'");
      }
    }
    var region = options.nameRegion || options.addressRegion;
    if (region) {
      region = Region.getRegionString(region);
    }
    var _options2 = options,
      element = _options2.element,
      style = _options2.style;
    var cldr = worldReady.globalize.cldr;
    this.fallback = options.fallback || "code";
    this.type = options.type;
    if (this.type === DISPLAY_NAME_TYPES.COARSE_ADDRESS_VALUES) {
      element = element === "state" ? "adminArea1" : "adminArea2";
    }
    var cldrDataMarketOverride, aux, regionalLabels;
    // ../metadata/metadata-v2.js ==> injects WorldReady's name & address metadata into CLDR metadata
    switch (options.type) {
      case DISPLAY_NAME_TYPES.PERSON_NAME:
        this.cldrData = Object.assign({}, cldr.main("peopleNames/00"), {}, cldr.main(["peopleNames", region]));
        break;
      case DISPLAY_NAME_TYPES.REGION:
        this.cldrData = Object.assign({}, cldr.main("localeDisplayNames/territories"));
        cldrDataMarketOverride = Object.assign({}, cldr.main(["marketOverrides", worldReady.region, "localeDisplayNames/territories"]));
        Object.assign(this.cldrData, cldrDataMarketOverride);
        break;
      case DISPLAY_NAME_TYPES.LANGUAGE:
        this.cldrData = Object.assign({}, cldr.main("localeDisplayNames/languages"));
        break;
      case DISPLAY_NAME_TYPES.MONTH:
        this.cldrData = Object.assign({}, cldr.main(["dates/calendars/gregorian/months", "stand-alone", style]));
        break;
      case DISPLAY_NAME_TYPES.DAY:
        {
          this.cldrData = Object.assign({}, cldr.main(["dates/calendars/gregorian/days", "stand-alone", style]));
          break;
        }
      case DISPLAY_NAME_TYPES.CURRENCY:
        {
          this.cldrData = {};
          Object.entries(cldr.main("numbers/currencies")).forEach(function (_ref) {
            var field = _ref[0],
              value = _ref[1];
            _this.cldrData[field] = value.displayName;
          });
        }
        break;
      case DISPLAY_NAME_TYPES.DATE_TIME_FIELD:
        aux = style === "long" ? "" : "-" + style;
        {
          this.cldrData = {};
          Object.entries(cldr.main("dates/fields")).filter(function (_ref2) {
            var field = _ref2[0];
            return field === "" + field.split("-")[0] + aux;
          }).forEach(function (_ref3) {
            var field = _ref3[0],
              value = _ref3[1];
            _this.cldrData[field.split("-")[0]] = value.displayName;
          });
        }
        break;
      case DISPLAY_NAME_TYPES.COARSE_ADDRESS:
        regionalLabels = cldr.main(["addresses/coarse", region]);
        if (!regionalLabels) {
          this.cldrData = {};
          break;
        }
        this.cldrData = regionalLabels === MESSAGE_MISSING ? Object.assign({}, cldr.main("addresses/coarse/00")) : Object.assign({}, cldr.main("addresses/coarse/00"), {}, regionalLabels);
        break;
      case DISPLAY_NAME_TYPES.PORTABLE_ADDRESS:
        regionalLabels = cldr.main(["addresses/portable", region]);
        if (!regionalLabels) {
          this.cldrData = {};
          break;
        }
        this.cldrData = regionalLabels === MESSAGE_MISSING ? Object.assign({}, cldr.main("addresses/portable/00")) : Object.assign({}, cldr.main("addresses/portable/00"), {}, regionalLabels);
        break;
      // for coarse and portable value we need to get either adminArea1 or adminArea2
      case DISPLAY_NAME_TYPES.COARSE_ADDRESS_VALUES:
      case DISPLAY_NAME_TYPES.PORTABLE_ADDRESS_VALUES:
        // Sanitize path by escaping slashes "/", e.g.: "bar/baz" becomes "bar_baz"
        element.replace(/[/]/g, "_");
        this.cldrData = Object.assign({}, cldr.main(["addresses/" + element, region]));
        break;
      case DISPLAY_NAME_TYPES.TERRITORY_NAME_SORT_KEY:
        this.cldrData = Object.assign({}, cldr.main("localeDisplayNames/territoryNameSortKey"));
        cldrDataMarketOverride = Object.assign({}, cldr.main(["marketOverrides", region, "localeDisplayNames/territoryNameSortKey"]));
        Object.assign(this.cldrData, cldrDataMarketOverride);
        break;
      case DISPLAY_NAME_TYPES.CURRENCY_NAME_SORT_KEY:
        this.cldrData = Object.assign({}, cldr.main("numbers/currencyNameSortKey"));
        break;
    }
    if (!Object.keys(this.cldrData).length) {
      validateCldr();
    }
  }

  /**
   * Check if 'properties' are valid based on the DisplayNames object's type.
   * If they are, return translated array. If they are not, return error.
   * @param {Array} properties
   * @returns {Array}
   */
  var _proto = DisplayNames.prototype;
  _proto.select = function select(properties) {
    var _this2 = this;
    // Error check
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(properties, "properties", ["array", "string"]);
    }
    if (Array.isArray(properties)) {
      return properties.map(function (prop) {
        return _this2.select(prop);
      });
    }
    var prop = getResolvedRegion(properties);
    var value = this.cldrData[prop] === null || this.cldrData[prop] === MESSAGE_MISSING ? null : this.cldrData[prop];
    // Fallback logic to support CLDR v43 language names
    if (this.type === DISPLAY_NAME_TYPES.LANGUAGE && !value) {
      for (var _iterator = _createForOfIteratorHelperLoose([].concat(inheritanceChain(new Cldr(prop), prop)).reverse()), _step; !(_step = _iterator()).done;) {
        var lang = _step.value;
        value = this.cldrData[lang] === null || this.cldrData[lang] === MESSAGE_MISSING ? null : this.cldrData[lang];
        if (value) {
          break;
        }
      }
    }
    // special case for territory/currency name sort key to retrun 0
    if (value === 0) {
      return 0;
    }
    return value || (this.fallback === "code" ? prop : undefined);
  };
  return DisplayNames;
}();

export { DisplayNames };
